import { useEffect, useState } from "react";
import { Typography, Row, Button, Checkbox, Col, Collapse, Badge } from "antd";
import axios from "axios";
import { Sector } from "@bindeleddet/core/types";
import { StyledCard } from "./style";

const { Panel } = Collapse;
const { Title, Text } = Typography;

interface Props {
  sectorsChecked: number[];
  toggleCheckedSectors: (id: number) => void;
  onFilterReset: () => void;
}

const CompaniesFilter: React.FC<Props> = ({ sectorsChecked, toggleCheckedSectors, onFilterReset }) => {
  const [sectors, setSectors] = useState<Sector[]>([]);

  useEffect(() => {
    axios.get<Sector[]>("/companies/sectors/").then(response => {
      setSectors(response.data);
    });
  }, []);

  return (
    <>
      <StyledCard bodyStyle={{ padding: "2em" }}>
        <Collapse ghost expandIconPosition="end" defaultActiveKey={["1"]}>
          {/* Sector */}
          <Panel
            header={
              <Badge color="#91CA91" dot={sectorsChecked.length > 0}>
                <Title level={5}>Bransje</Title>
              </Badge>
            }
            key="1"
          >
            <Row>
              {sectors.map(sector => {
                if (!sector.name) return null;
                return (
                  <Col xs={12} sm={6} md={24} key={sector.id}>
                    <Checkbox
                      checked={sectorsChecked.includes(sector.id)}
                      onChange={() => toggleCheckedSectors(sector.id)}
                    >
                      <Text>{sector.name}</Text>
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Panel>
        </Collapse>

        {/* Reset filter button */}
        <Row style={{ paddingTop: "2em" }} justify="center">
          <Button danger block onClick={onFilterReset}>
            Nullstill filtrering
          </Button>
        </Row>
      </StyledCard>
    </>
  );
};

export default CompaniesFilter;
